import { ReactNode } from 'react';
import BackArrow from 'assets/images/backArrow.svg';
import { useTranslation } from '@packages/utils';
import {
  BackButton,
  RegistrationContentFooter,
  NextStepButton,
} from '../RegistrationContent/RegistationContent.style';
import { Image } from '../../../../../Base/Image';
import useRegistrationContext from '../../context/NewRegistrationModalContext';
import { chooseLanguageSecionKey } from '../../../RegistrationModal/RegistrationModal.data';

const BackNextButtons = ({
  isNextDisabled = false,
  customNextButton,
  children,
  onBack,
  onNext,
}: {
  onBack?: () => void;
  onNext?: () => void;
  customNextButton?: boolean;
  children?: ReactNode;
  isNextDisabled?: boolean;
}) => {
  const { t } = useTranslation({
    keyPrefix: chooseLanguageSecionKey,
    lng: 'translate',
  });
  const {
    stepper,
    setStepper,
    handleSubmit,
    registrationValues: { acceptedTerms, recaptchaResponse },
    isRegistrationLoading,
  } = useRegistrationContext();

  const stepperButtonLabel = () => {
    switch (stepper) {
      case 0:
        return 'LETS_START_BTN';
      case 3:
        return 'REGISTER_BTN';
      default:
        return 'NEXT_STEP_BTN';
    }
  };

  return (
    <RegistrationContentFooter>
      {stepper > 0 && (
        <BackButton
          onClick={() => {
            if (onBack) {
              onBack();
            } else if (stepper > 0) setStepper(stepper - 1);
          }}
          data-cy="registration-back-button"
        >
          <Image height={20} width={20} alt="Back Arrow" src={BackArrow} />
          <span className="back-text">Back</span>
        </BackButton>
      )}
      {customNextButton ? (
        <>{children}</>
      ) : (
        <NextStepButton
          color="primary"
          type="primary"
          disabled={
            (stepper === 3 ? !acceptedTerms || !recaptchaResponse : false) ||
            isRegistrationLoading ||
            isNextDisabled
          }
          onClick={() => {
            if (onNext) {
              onNext();
            } else if (stepper < 3) setStepper(stepper + 1);
            else if (stepper === 3) {
              handleSubmit();
            }
          }}
          data-cy="registration-next-button"
        >
          {t(`${stepperButtonLabel()}`)}
        </NextStepButton>
      )}
    </RegistrationContentFooter>
  );
};

export default BackNextButtons;
